/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Differences_Actions_HeadingInputs */

const en_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differences & Actions`)
};

const fr_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Différences et actions`)
};

const de_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterschiede und Maßnahmen`)
};

const it_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Differenze e azioni`)
};

const ru_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Различия и действия`)
};

const es_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferencias y acciones`)
};

const zh_cn2_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`差异与行动`)
};

const ja_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`違いと行動`)
};

const hi_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतर और कार्य`)
};

const pt_pt2_compare_event_groups_differences_actions_heading = /** @type {(inputs: Compare_Event_Groups_Differences_Actions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diferenças e ações`)
};

/**
* | output |
* | --- |
* | "Differences & Actions" |
*
* @param {Compare_Event_Groups_Differences_Actions_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_differences_actions_heading = /** @type {((inputs?: Compare_Event_Groups_Differences_Actions_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Differences_Actions_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_differences_actions_heading(inputs)
	if (locale === "de") return de_compare_event_groups_differences_actions_heading(inputs)
	if (locale === "it") return it_compare_event_groups_differences_actions_heading(inputs)
	if (locale === "ru") return ru_compare_event_groups_differences_actions_heading(inputs)
	if (locale === "es") return es_compare_event_groups_differences_actions_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_differences_actions_heading(inputs)
	if (locale === "ja") return ja_compare_event_groups_differences_actions_heading(inputs)
	if (locale === "hi") return hi_compare_event_groups_differences_actions_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_differences_actions_heading(inputs)
	return en_compare_event_groups_differences_actions_heading(inputs)
});